import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ConnectGmcPage = lazy(() => import('~/features/onboarding/pages/connect-gmc-screen'));

/** `connectionId` present → edit an existing GMC connection (prefill + PATCH);
 *  absent → the normal create flow. */
const searchSchema = z.object({
  connectionId: z.string().optional(),
});

function ConnectGmcRouteComponent() {
  const { connectionId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectGmcPage connectionId={connectionId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/google/google-merchant-center',
)({
  validateSearch: searchSchema,
  component: ConnectGmcRouteComponent,
});
